import type {ReactElement} from 'react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'
import {Box} from '@primer/react'
import type {SectionFilterLink} from './SectionFilterLink'

export type SectionFilterLinks = Array<ReactElement<typeof SectionFilterLink>>

type SectionFiltersProps = {
  links: SectionFilterLinks
}

const ulStyles: BetterSystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
}

export const SectionFilters = ({links}: SectionFiltersProps) => {
  if (links.length < 1) return null

  return (
    <div {...testIdProps('listview-section-filters')}>
      <Box as="ul" sx={ulStyles} className="list-style-none">
        {links.map((sectionFilterLink, index) => (
          <li key={`section-filter-${index}`} {...testIdProps(`listview-section-filter-${index}`)}>
            {sectionFilterLink}
          </li>
        ))}
      </Box>
    </div>
  )
}

try{ SectionFilters.displayName ||= 'SectionFilters' } catch {}